import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import template from 'lodash.template';

import { fetchLandingPageInfo } from 'actions/landing/landingPageInfo';
import LandingSlot from 'containers/LandingSlot';

import css from 'styles/components/search/noSearchResults.scss';

export class NoSearchResults extends Component {
  static contextTypes = {
    testId: PropTypes.func,
    marketplace: PropTypes.object
  };

  componentDidMount() {
    const { fetchLandingPageInfo } = this.props;

    fetchLandingPageInfo('no-search-results');
  }

  makeDynamicBelowTheFoldContent = () => {
    const { landingPage: { pageInfo: { slotData }, slotOrder }, isVip } = this.props;
    const {
      testId,
      marketplace: {
        phoneNumber,
        phoneNumberVip,
        error: {
          contactVerbiage
        } = {}
      }
    } = this.context;
    const number = isVip ? phoneNumberVip : phoneNumber;
    const contactMessage = contactVerbiage && template(contactVerbiage)({ phoneNumber: number });
    return (
      <>
        {slotOrder.map(slotName => (
          <LandingSlot
            key={slotName}
            slotName={slotName}
            data={slotData[slotName]}
            onComponentClick={f => f}/>
        ))}

        {contactMessage &&
        <p
          className={css.contact}
          data-test-id={testId('contactUs')}
          dangerouslySetInnerHTML={{ __html: contactMessage }}/>
        }
      </>);
  };

  render() {
    const {
      filters: { originalTerm },
      landingPage: { isLoaded }
    } = this.props;
    const { testId } = this.context;

    return (
      <div className={css.container} data-test-id={testId('noSearchResults')}>
        <div className={css.noResults}>
          <h1 data-test-id={testId('noResultsHeader')}>No Results Found</h1>
          <p data-test-id={testId('noResultsMessage')}>{originalTerm && `We couldn't find any results for ${originalTerm}.`} Try a different search or browse the categories below:</p>
        </div>

        { isLoaded && this.makeDynamicBelowTheFoldContent()}
      </div>
    );
  }
}

const mapStateToProps = ({ filters, landingPage, rewards }) => {
  const { consented, vip } = rewards?.rewardsInfo || {};
  const isVip = consented || vip;
  return {
    filters,
    landingPage,
    isVip
  };
};

export default connect(mapStateToProps, { fetchLandingPageInfo })(NoSearchResults);
